export enum RequirementsNpaActionsEnum {
  GET_NPA_COUNT = 'GET_NPA_COUNT',
  SET_NPA_COUNT = 'SET_NPA_COUNT',
  SET_NPA_SOURCE = 'SET_NPA_SOURCE',
  SET_FORM_REF = 'SET_FORM_REF',
  GET_NPA_LIST = 'GET_NPA_LIST',
  SET_NPA_LIST = 'SET_NPA_LIST',
  SET_MODAL_MODE = 'SET_MODAL_MODE',
  SET_SELECTED_NPA = 'SET_SELECTED_NPA',
  GET_STRUCTURAL_UNIT_LIST = 'GET_STRUCTURAL_UNIT_LIST',
  SET_STRUCTURAL_UNIT_LIST = 'SET_STRUCTURAL_UNIT_LIST',
  ADD_TO_STRUCTURAL_UNIT_LIST = 'ADD_TO_STRUCTURAL_UNIT_LIST',
  GET_MANDATORY_LIST = 'GET_MANDATORY_LIST',
  SET_MANDATORY_LIST = 'SET_MANDATORY_LIST',
  SET_SELECTED_MANDATORY = 'SET_SELECTED_MANDATORY',
  ADD_SELECTED_MANDATORY = 'ADD_SELECTED_MANDATORY',
  SET_IS_MANDATORY_CREATED = 'SET_IS_MANDATORY_CREATED',
  RESET_MODAL_LISTS = 'RESET_MODAL_LISTS',
  CREATE_NPA = 'CREATE_NPA',
  CREATE_SUS = 'CREATE_SUS',
  CREATE_SUS_WITH_MANDATORY = 'CREATE_SUS_WITH_MANDATORY',
  SET_IS_NPA_STRUCTURE_CHANGED = 'SET_IS_NPA_STRUCTURE_CHANGED',
  EDIT_NPA = 'EDIT_NPA',
  SET_SAVED_NPA = 'SET_SAVED_NPA',
  SET_OIV_CONTROL_ID = 'SET_OIV_CONTROL_ID',
  SET_OIV_CONTROL_TYPE_ID = 'SET_OIV_CONTROL_TYPE_ID',
  CREATE_STRUCTURAL_UNITS = 'CREATE_STRUCTURAL_UNITS',
  CREATE_MANDATORY_LIST = 'CREATE_MANDATORY_LIST',
  ADD_NPA_MODAL_NOTICE = 'ADD_NPA_MODAL_NOTICE',
  REMOVE_NPA_MODAL_NOTICE = 'REMOVE_NPA_MODAL_NOTICE',
  REMOVE_ALL_NPA_MODAL_NOTICES = 'REMOVE_ALL_NPA_MODAL_NOTICES',
  SHOW_VALIDATION_NOTICE = 'SHOW_VALIDATION_NOTICE',
  SET_IS_NPA_CREATED = 'SET_IS_NPA_CREATED',
  SET_IS_SU_CREATED = 'SET_IS_SU_CREATED',
  SET_IS_NPA_EDITED = 'SET_IS_NPA_EDITED',
  SET_IS_STRUCTURAL_UNIT_CREATED = 'SET_IS_STRUCTURAL_UNIT_CREATED',
  SET_IS_NPA_LIST_DIRTY = 'SET_IS_NPA_LIST_DIRTY',
  SET_IS_NPA_EDITED_WITH_ERROR = 'SET_IS_NPA_EDITED_WITH_ERROR',
  SET_IS_LIST_STRUCTURAL_UNIT_LOADED = 'SET_IS_LIST_STRUCTURAL_UNIT_LOADED',
  SET_CREATED_SELECTED_STRUCTURAL_UNITS = 'SET_CREATED_SELECTED_STRUCTURAL_UNITS',
  SET_ID_MAP = 'SET_ID_MAP',
  GET_NPA_LIST_NEW = 'GET_NPA_LIST_NEW',
  SET_NPA_LIST_NEW = 'SET_NPA_LIST_NEW',
  GET_CURRENT_NPA = 'GET_CURRENT_NPA',
  SET_CURRENT_NPA = 'SET_CURRENT_NPA',
  REQUIREMENTS_NPA_FIND_SELECT_OPTIONS_BY_QUERY = 'REQUIREMENTS_NPA_FIND_SELECT_OPTIONS_BY_QUERY',
}
